import { render, staticRenderFns } from "./CommunityPostActivity.vue?vue&type=template&id=f667906a&scoped=true&"
import script from "./CommunityPostActivity.vue?vue&type=script&lang=js&"
export * from "./CommunityPostActivity.vue?vue&type=script&lang=js&"
import style0 from "./CommunityPostActivity.vue?vue&type=style&index=0&id=f667906a&scoped=true&lang=sass&"
import style1 from "./CommunityPostActivity.vue?vue&type=style&index=1&id=f667906a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f667906a",
  null
  
)

export default component.exports